const SOCIAL_MEDIA = {
    INSTAGRAM: 'INSTAGRAM',
    FACEBOOK: 'FACEBOOK',
    TWITTER: 'TWITTER',
    PINTEREST: 'PINTEREST',
    LINKEDIN: 'LINKEDIN',
    YOUTUBE: 'YOUTUBE',
}

const environment = {
    DEV: {
        BACKEND_URL: "http://localhost:8080"
    },
    PROD: {
        BACKEND_URL: "https://api2.phros.ca"
    }
}

const UID = "wDcTtoCPb9NcXDvexhhzptk50dx2";

module.exports = {
    SOCIAL_MEDIA,
    ENVIRONMENT: environment.PROD,
    UID,
}